import { TransactionStatePublic } from '@app/core/resources/transaction-state-public';
import { Transaction } from '../../transaction';

export class TransactionPublicHelper {
    public transaction: Transaction = new Transaction();

    public transformTransactionStateToTransaction(transactionStatePublic: TransactionStatePublic): Transaction {
        let arrayState: Array<any> = transactionStatePublic.relationships.states.data;

        this.transaction.attributes.__operation = null;
        this.transaction.attributes.email = transactionStatePublic.attributes.email;
        this.transaction.attributes.mid = transactionStatePublic.attributes.mid;
        this.transaction.attributes.amount1 = transactionStatePublic.attributes.amount1;
        this.transaction.attributes.created_at = arrayState[0].attributes.updated_at;
        this.transaction.attributes.amount2 = transactionStatePublic.attributes.amount2;
        this.transaction.attributes.state = arrayState[arrayState.length - 1].attributes.state;
        this.transaction.relationships.states = transactionStatePublic.relationships.states;
        this.transaction.relationships.system1 = transactionStatePublic.relationships.system1;
        this.transaction.relationships.system2 = transactionStatePublic.relationships.system2;

        return this.transaction;
    }
}
